// Import React library
import React from 'react'; 
import PropTypes from 'prop-types';
// To connect to store 
import { connect } from 'react-redux';
// (Here) for Validation engine
import util from '../../lib/util';
import * as selectors from '../../selectors/CustomerDetails';
import * as consts from '../../constants';
// Import components
import CustomerType from '../Sections/CustomerDetails/CustomerType';
import Residential, { ResidentialValidation } from '../Sections/CustomerDetails/Residential';
import Commercial, { CommercialValidation } from '../Sections/CustomerDetails/Commercial';
import StepNavButtons from '../Sections/StepNavButtons';
// Actions for customer details 
import { createAccount, updateAccount, searchAccount } from '../../actions/index';
import { nextStepClicked } from '../../actions';
import Modal from 'react-bootstrap/lib/Modal';


//Step 2
class CustomerDetails extends React.Component {
    constructor() {
        super();
      
        this.state = { createBupa: false,   isModalOpen : false, isAccountSkipped : false, accountNo : null};
    }
   
    componentWillReceiveProps(p) {
       
        if (p.bupaCreated && this.state.createBupa) {
            this.setState({ createBupa: false });
          
            this.handleNextClick(p);
        }

        if(p.isNewAccount && !(p.bupaVerified || p.bupaCreated) ) {
            const model = {
                ...p.businessPartnerModel,                   
                Identifications: [p.idTypeModel]
            };    

            if (model && model.Identifications && model.Identifications.length>0 && model.Identifications[0].Value && 
                   ((model.FirstName &&  model.LastName && model.DOB && p.customerType == "1") || (model.BusinessName &&  model.PrimaryPhone  &&  util.isBNValid(p.form.idType_BusinessNumber) &&  util.isPhoneValid(model.PrimaryPhone) &&  p.customerType != "1"))
                     && !p.isSearchBPCalled ) {
            
                p.onSearchBuPa(model);
                this.setState({ isShowWaitPopup: true });              
            }
        }
     
        if(p.bpSearchResult && p.bpSearchResult.data && p.bpSearchResult.data.items
             && p.bpSearchResult.data.items.length>0  && !(p.bupaVerified || p.bupaCreated)) {
            this.setState({ isModalOpen: true });              
        }
    }
    onSelectAccount = (x)=> {
       this.props.onLoadAccount(x.bpNumber);
        this.setState({ accountNo: x.baNumber });
        this.setState({ isModalOpen: false });
        this.props.resetBPSearch();

    }

    onSkipAccount = ()=> {
        this.setState({ isAccountSkipped: true });
        this.setState({ isModalOpen: false });
         this.props.resetBPSearch();
    }
    nextClick = () => {
        const p = this.props;
        const form = p.form;
        const retriesExceed = p.verifyAccountRetriesExceed;
        const hasBilling = (p.productName !== consts.SERVICE_REMOVAL_NAME);
        let validators = [];
        switch (form.customerType) {
            case "1":
                validators = [...ResidentialValidation(form, retriesExceed, hasBilling)];
                break;
            case "2":
            case "3":
                validators = [...CommercialValidation(form, retriesExceed, hasBilling)];
        }
        if (util.validate(validators, form, p.formError)) {
            if (retriesExceed)
                this.handleNextClick(p);
            else {
                const businessPartnerModel = {
                    ...this.props.businessPartnerModel,
                    Address: p.addressModel,
                    Identifications: [p.idTypeModel],
                    IsAccountSkipped : this.state.isAccountSkipped,
                    FoundBPs : p.bpSearchResult && p.bpSearchResult.data && p.bpSearchResult.data.items                   
                };
                this.setState({ createBupa: true });
                if (p.bupaVerified || p.bupaCreated) {
                    if(!businessPartnerModel.BaNumber && this.state.accountNo)
                        businessPartnerModel.BaNumber = this.state.accountNo;
                    p.onUpdateBupa(businessPartnerModel, p.businessAgreementModel);
                }
                else {             
                    // true for abandonment and false for new service 
                  businessPartnerModel.NoCreditCheck =  (p.productName == consts.SERVICE_REMOVAL_NAME);
                  p.onCreateBuPa(businessPartnerModel);
                }
               
            }
        }
    }
     handleNextClick= (p) => {
         if (!p.isLoggedIn && p.verifyAccountRetriesExceed && p.productName == consts.SERVICE_REMOVAL_NAME) {
           p.onNextStepClicked(3);
         }
         else
            p.onNextClick();
    }
    render() {
        const p = this.props;
        let ResidentialOrCommercial = null;
        const hasBilling = (p.form.productName !== consts.SERVICE_REMOVAL_NAME);
        switch (p.customerType) {
            case "1":
                ResidentialOrCommercial = <Residential hasBilling={hasBilling}  accountNo={this.state.accountNo} allowDOBEdit={p.allowDOBEdit} pageName={p.productName} />;
                break;
            case "2":
            case "3":
                ResidentialOrCommercial = <Commercial hasBilling={hasBilling} accountNo={this.state.accountNo} allowDOBEdit={p.allowDOBEdit} pageName={p.productName} />;
                break;
        }
        // Show next button based on:
        // not being exisitng ForticBC account holder or 
        // if Business Partner account has verified
        const nextButton = (((p.exisitngFortisBCCustomer == 1) && (!p.bupaVerified)) && !p.verifyAccountRetriesExceed) ?
            null : <StepNavButtons text="Next step" onNextClick={this.nextClick} onBackClick={p.onBackClick} onCancelClick={p.onCancelClick} />;

        let customerType = null;
        if (p.bupaVerified && !p.bupaChecked)
            customerType = null;
        else
            customerType = <CustomerType lookup={window.osa.lookup.customerDetails.customerTypes} disabled={(p.bupaChecked && p.bupaVerified) || p.bupaCreated} />;

        const foundBPs =   p.bpSearchResult && p.bpSearchResult.data && p.bpSearchResult.data.items;
        const name = p.businessPartnerModel && p.customerType == "1" ? p.businessPartnerModel.FirstName + ' ' + p.businessPartnerModel.LastName : p.businessPartnerModel.BusinessName;
        return (
            <div>               
             <Modal show={this.state.isModalOpen}>
              <Modal.Header>
                  <Modal.Title>Select account</Modal.Title>
              </Modal.Header>
              <Modal.Body>     
                { 
                  foundBPs && foundBPs.length>0 ?
                  <div>                             
                  { 
                    foundBPs.length>1 ?  
                    <div>
                        {
                        foundBPs.map((x) => 
                                
                                    <div className="row">
                                        <div className="col-md-1"> </div>
                                        <div className="col-md-2"> {name} </div> 
                                        <div className="col-md-5"> {x.address}  </div> 
                                        <div className="col-md-4"><a onClick={this.onSelectAccount.bind(this,x)}>Select this account</a></div>                                                     
                                    </div>                           
                            ) 
        
                        }
                        <div className="row">
                            <div className="col-md-1"> </div>
                            <div className="col-md-2"><a onClick={ this.onSkipAccount }>Skip</a></div>  
                            <div className="col-md-9"></div>  
                        </div>                    
                    </div>
                    : 
                     <div>
                        {
                        foundBPs.map((x) => 
                                <div>
                                    <div className="row">
                                        <div className="col-md-1"> </div>
                                        <div className="col-md-2"> {name} </div> 
                                        <div className="col-md-9"> {x.address}  </div>                                                                                         
                                    </div>      
                                    <br/>
                                     <div className="row">
                                        <div className="col-md-1"> </div>
                                        <div className="col-md-4"><a onClick={this.onSelectAccount.bind(this,x)}>Select this account</a></div>    
                                        <div className="col-md-2"><a onClick={ this.onSkipAccount }>Skip</a></div>  
                                        <div className="col-md-5"></div>  
                                    </div>
                                </div>                         
                            ) 
        
                        }
                                     
                    </div>
                }   
                   </div>
                :  null
                }
              </Modal.Body>           
          </Modal>
                <h4 className="text-primary">By completing this step you are creating a FortisBC gas account.</h4>
                <br/>
                {customerType}
                {ResidentialOrCommercial}
                {nextButton}
            </div>
        );
    }
}
// props
CustomerDetails.propTypes = {
    id: PropTypes.string.isRequired,
    onNextClick: PropTypes.func.isRequired,
    onBackClick: PropTypes.func.isRequired,
    onCancelClick: PropTypes.func.isRequired,
    onCreateBuPa: PropTypes.func,
    onSearchBuPa: PropTypes.func,
    businessPartnerModel: PropTypes.object,
    businessAgreementModel: PropTypes.object,
    bpSearchResult: PropTypes.object,
    isNewAccount : PropTypes.bool,
    isSearchBPCalled : PropTypes.bool  
};
// Dispatch actions
function mapDispatchToProps(dispatch) {
    return {
        onLoadAccount: (bpNumber) => dispatch({ type: 'LOAD_ACCOUNT', baNumber: '', bpNumber}),
        onCreateBuPa: (params) => dispatch(createAccount(params)),
        onSearchBuPa: (params) => dispatch(searchAccount(params)),
        onUpdateBupa: (bp, ba) => dispatch(updateAccount(bp, ba)),        
        resetBPSearch : () => dispatch({ type: 'BUPA_SEARCHED' , data : null }),
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
             onNextStepClicked: (activeIndex) => dispatch(nextStepClicked(activeIndex)),
    };
}
// Attach state values to props
const mapStateToProps = (state) => {
    return {
        form: state.form,
        customerType: state.form.customerType,
        bupaChecked: state.gas.bupaChecked,
        bupaVerified: state.form.bupaVerified,
        businessPartnerModel: selectors.selectBusinessPartnerModel(state),
        businessAgreementModel: selectors.selectBusinessAgreementModel(state),
        addressModel: selectors.selectBillingAddressModel(state,"billingAddress"),
        idTypeModel: selectors.selectIdTypeModel(state),
        exisitngFortisBCCustomer: state.form.fortisBCAccount,
        loggedInbupaNumber: selectors.selectloggedInbupaNumber(state),
        activeIndex: state.gas.activeIndex,
        bupaCreated: state.gas.bupaCreated,
        verifyAccountRetriesExceed: state.gas.verifyAccountExceed,
        productName: state.gas.pageName,
        isNewAccount : state.form.fortisBCAccount == "2",
        bpSearchResult : state.gas.bpSearchResult,
        allowDOBEdit :state.gas.allowDOBEdit,
        isSearchBPCalled : state.gas.isSearchBPCalled
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(CustomerDetails);